import Vue from 'vue'
import App from './App.vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/main.css"
import router from "@/router";
import { BootstrapVue } from 'bootstrap-vue'
import VueMobileDetection from "vue-mobile-detection";
Vue.config.productionTip = false

Vue.use(VueMobileDetection)
Vue.use(BootstrapVue)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
